import { getDayDateRange } from './dateUtils';
import { getHabitEntries } from '../habitService';
import { normalizeDailyCareEntry } from '../../hooks/timeline/timelineSourceNormalizers';

/**
 * Get daily habit entries for a specific child and date
 * This fetches from mood, sleep, food, and custom habit logs
 * @param {string} childId - Child ID
 * @param {Date} selectedDate - Date to fetch habits for
 * @returns {Promise<Array>} - Array of habit entry objects
 */
export const getDailyHabits = async (childId, selectedDate) => {
  try {
    const { start, end } = getDayDateRange(selectedDate);
    
    // Use the existing habitService to get all habit entries
    const habitEntries = await getHabitEntries(childId, start, end);
    
    // Transform the data to match timeline format and ensure childId is set
    return habitEntries.map((entry) => normalizeDailyCareEntry({
      ...entry,
      childId, // Ensure childId is explicitly set
      collection: 'dailyCare',
      actionType: entry.actionType || entry.data?.actionType || null,
      timestamp: entry.timestamp?.toDate ? entry.timestamp.toDate() : new Date(entry.timestamp),
    }));
    
  } catch (error) {
    console.error('Error fetching daily habits:', error);
    return [];
  }
};

export const getDailyHabitsInRange = async (childId, startDate = null, endDate = null) => {
  try {
    const habitEntries = await getHabitEntries(childId, startDate, endDate);

    return habitEntries.map((entry) => normalizeDailyCareEntry({
      ...entry,
      childId,
      collection: 'dailyCare',
      actionType: entry.actionType || entry.data?.actionType || null,
      timestamp: entry.timestamp?.toDate ? entry.timestamp.toDate() : new Date(entry.timestamp),
    }));
  } catch (error) {
    console.error('Error fetching daily habits in range:', error);
    return [];
  }
};
